import { ReactComponent as CopyIconGray } from "assets/icons/CopyIconGray.svg";
import LocationSvg from "assets/icons/svg/localtion";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import CopyButton from "../CopyButton/CopyButton";
import "./index.scss";
const DropdownIndicator = (props) => {
  return (
    <div className="px-2">
      <LocationSvg label="Emoji" />
    </div>
  );
};

// inputLike: render the field like the app's InputField (padding, weight, colours)
const FindMyCity = ({ rowTitle, title, value, handleChange, titleStyles,copy,labelCopy,copyAddressHandler,isCopied, saveNewAddress, inputLike }) => {
  let orgData = JSON.parse(
    localStorage.getItem("organization") !== "undefined"
    ? localStorage.getItem("organization")
    : "{}"
  );
  const countryCode = orgData?.country?.code || "us";

  const [inputText, setInputText] = useState(value?.label || '');

  return (
    <div className={`map-title${inputLike ? " map-title--input-like" : ""}`}>
      <div style={{ fontSize: "14px", marginBottom: "10px", ...titleStyles }} className="map-title__label d-flex align-items-center justify-content-between">
        {title}
        {!!labelCopy && (
        <div className="ml-5 cursor-pointer position-relative"
          onClick={() => {
            copyAddressHandler();
          }}
        >
          <CopyToClipboard text={value}>
            <CopyIconGray />
          </CopyToClipboard>
          {isCopied && (
            <div className="copy-value__hint copy-value__hint--address">
              {"Copied"}
            </div>
          )}
        </div>
      )}
      </div>
      <div>
        <Row>
          {rowTitle && (
            <Col xs={4}>
              <div className="container-title">{rowTitle}</div>
            </Col>
          )}
          <Col>
            <GooglePlacesAutocomplete
              className="d-flex form-control form-control-solid px-6 pt-8 pb-9 align-items-center"
              apiKey={"AIzaSyCAt0TjvU_m8ufUMYn2EXi9mteHSOUB7uA"}
              selectProps={{
                value,
                classNamePrefix: "find-my-city",
                onChange: handleChange,
                onInputChange: (newValue) => setInputText(newValue),
                onBlur: saveNewAddress ? () => {
                  if (inputText?.trim()?.length && inputText !== value?.label) {
                    handleChange({ label: inputText, value: { place_id: null } });
                  }
                } : null,
                components: {
                  DropdownIndicator,
                  IndicatorSeparator: () => null,
                },
                placeholder: "Enter Address",
              }}
              autocompletionRequest={{
                componentRestrictions: {
                  country: [countryCode?.toLowerCase()],
                },
              }}
              apiOptions={{ language: "en", region: countryCode?.toLowerCase() }}
            />
            {(copy && value?.label) && (
                <CopyButton value={value?.label} styles={{right: "40px"}} />
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default FindMyCity;
